var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('p',[_vm._v(" 声明：本平台展示的废旧物资价格行情相关数据、资讯等信息仅供参考。 ")]),_c('p',[_vm._v(" 本平台对相关信息及数据准确性不承担责任。 ")])])
}]

export { render, staticRenderFns }